import { Flex, Heading, Box, useDisclosure, Text } from '@chakra-ui/core'
import React from 'react'
import { Maybe, TasksWithCount } from '../../../../generated/graphql'
import ListItem from './ListItem'
import { useAppContext } from '../../../../context/AppProvider'
import { usePreviewerContext } from '../../../../context/PreviewerProvider'
import { BsFolderPlus } from 'react-icons/bs'
import DataFields from '../DataFields'
import { AlertModal, EmptyListHandler, Pagination } from '../../../../components'

type ListProps = {
  tasks: Maybe<TasksWithCount>
  pagination?: {
    start?: number
    limit?: number
    setStart?: React.Dispatch<React.SetStateAction<number>>
    setLimit?: React.Dispatch<React.SetStateAction<number>>
  }
}
const List: React.FC<ListProps> = ({ tasks, pagination }) => {
  const { setPreviewComponent, formIsDirty, setFormIsDirty } = usePreviewerContext()
  const { toggleDrawer2, drawerOpen2 } = useAppContext()
  const [selectedTask, setSelectedTask] = React.useState<string | null>(null)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const onConfirm = React.useRef(() => {
    toggleDrawer2(true)
    setPreviewComponent?.({
      title: '',
      icon: BsFolderPlus,
      content: <DataFields task={null} />
    })
  })

  return (
    <>
      <AlertModal
        activatorStatus="warning"
        onConfirm={() => {
          onConfirm.current()
          setFormIsDirty?.(false)
          onClose()
        }}
        isOpen={isOpen}
        confirmButtonText="Confirm"
        onClose={onClose}
        title="Unsaved Changes"
      >
        <Heading fontSize="xs">
          You have unsaved changes. Are you sure you want to continue?
        </Heading>
        <Text fontSize="xs" mt={5}>
          Any unsaved changes will be lost if you proceed.
        </Text>
      </AlertModal>

      <Flex wrap="wrap" w="100%" direction="column">
        <Heading size="xs" mb={3}>
          My Tasks ({tasks?.count || 0})
        </Heading>
        {tasks?.data?.length ? (
          tasks?.data?.map((task) => {
            const selected = selectedTask === task?.id
            return (
              <ListItem
                key={task?.id}
                task={task}
                bg={selected ? 'green.50' : 'white'}
                border="1px solid"
                borderColor={selected ? 'green.100' : 'transparent'}
                onClick={() => {
                  if (selectedTask === task?.id) {
                    toggleDrawer2(true)
                    return
                  }
                  const select = () => {
                    setSelectedTask?.(task?.id || null)

                    setPreviewComponent?.({
                      title:
                        task?.attributes?.task_definition?.data?.attributes?.task_type?.data
                          ?.attributes?.title || '',
                      icon: BsFolderPlus,
                      content: <DataFields task={task} key={`${task?.id}-${Date.now()}`} />
                    })

                    toggleDrawer2(true)
                  }
                  if (formIsDirty) {
                    onOpen()
                    onConfirm.current = select

                    toggleDrawer2(true)
                    return
                  }
                  select()
                }}
              />
            )
          })
        ) : (
          <EmptyListHandler
            title="No tasks found"
            subTitle="You have not reported any tasks yet."
          />
        )}
        {pagination && (
          <Box mb={16} mt={4} w="100%">
            <Pagination
              setLimit={pagination?.setLimit}
              start={pagination?.start}
              setStart={pagination?.setStart}
              count={tasks?.count || 0}
              limit={pagination?.limit}
              pageRangeDisplayed={drawerOpen2 ? 4 : 8}
            />
          </Box>
        )}
      </Flex>
    </>
  )
}

export default List
